export function metersToInches(value, metric){
  const meters = Number(value);
  if(metric){
    if(meters > 1){
      return Math.round(meters * 1000) / 1000 + "<span class='unit'>m</span>"
    }else{
      return Math.round(meters * 100) + "<span class='unit'>cm</span>"
    }
  }else{
    const denominator = 16;
    const feet = meters * 3.280839895;

    let ft = Math.floor(feet);
    let inchs = Math.floor((feet - ft) * 12);
    let remaninder = Math.round((((feet - ft) * 12) - inchs) * denominator);

    if(feet - ft > 0.99999){
        ft = Math.ceil(feet);
        inchs = 0;
        remaninder = 0;
    }

    if(((feet - ft) * 12) - inchs > 0.99999){
        inchs = Math.ceil((feet - ft) * 12);
        remaninder = 0;
    }

    const gcd = getGcd(remaninder, denominator);

    const ftString = ft > 0 ? ft+"<span class='unit'>\'</span> " : "";
    const inString = inchs > 0 ? inchs+"" : "";
    const remaninderString = remaninder > 0 && remaninder / denominator != 1 ? " <span class='fraction'>"+remaninder/gcd+"/"+denominator/gcd+"</span><span class='unit'>\"</span>" : inchs > 0 ? "<span class='unit'>\"</span>" : "";

    return ftString + inString + remaninderString;
  }
  // return (Number(value) * 39.3701) +'in';
}

export function getGcd(_x, _y){
  let x = Math.abs(_x);
  let y = Math.abs(_y);
  while(y > 0){
    let t = y;
    y = x % y;
    x = t;
  }
  return x;
}

export function getPricePartType(stockUom){
  const stock = stockUom.toLowerCase();
  switch(stock){
    case "mm":
    case "cm":
    case "m":
    case "in":
    case "ft":
      return 'length';
    case "smm":
    case "scm":
    case "sm":
    case "sin":
    case "sf":
      return 'square'
    default:
      return 'per'
  }
}

export function convertPartPriceToMeters({sellingPrice, stockUom}){
  const stock = stockUom.toLowerCase();
  switch(stock){
    case "mm":
      return sellingPrice * 1000;
    case "cm":
      return sellingPrice * 100;
    case "m":
      return sellingPrice;
    case "in":
      return sellingPrice * 39.3701;
    case "ft":
      return sellingPrice * 3.28084;
    default:
      return sellingPrice;
  }
}
export function convertPartPriceToSquareMeters({sellingPrice, stockUom}){
  const stock = stockUom.toLowerCase();
  switch(stock){
    case "smm":
      return sellingPrice * 1000000;
    case "scm":
      return sellingPrice * 10000;
    case "sm":
      return sellingPrice;
    case "sin":
      return sellingPrice * 1550;
    case "sf":
      return sellingPrice * 10.7639
    default:
      return sellingPrice;
  }
}

export function getNumber(price){
  if(price && String(price).match(/\d.*/g)){
    return parseFloat(String(price).match(/\d.*/g).join(""));
  }else{
    return 0
  }
}
export function round(num){

  return Math.round(num * 10000) / 10000
}
export function roundDollars(num){
  return Math.round(num * 100) / 100
}

export function getPriceLabel(price){
  if(price){
    if(price.stockUom.toLowerCase() == "ea"){
      return "$"+roundDollars(price.sellingPrice);
    }else if(price.stockUom.toLowerCase() == "in"){
      return "$"+roundDollars(price.sellingPrice * 12)+" ft";
    }else if(price.stockUom.toLowerCase() == "ft"){
      return "$"+roundDollars(price.sellingPrice)+" ft";
    }else if(price.stockUom.toLowerCase() == "m"){
      return "$"+roundDollars(price.sellingPrice)+" meter";
    }else if(price.stockUom.toLowerCase() == "mm"){
      return "$"+roundDollars(price.sellingPrice*1000)+" meter";
    }else if(price.stockUom.toLowerCase() == "cm"){
      return "$"+roundDollars(price.sellingPrice*100)+" meter";
    }
    return "$"+roundDollars(price.sellingPrice) + " " + price.stockUom;
  }
  return "...";
}

export function getPriceDiscount(price){
  if(price && price.discount){
    return price.discount
  }
  return null;
}